<template>
  <section>
    <header-match :first-product="page.eerste_product" :second-product="page.tweede_product" :introduction="page.introductie"/>
    <call-to-action
      title="Dit wil ik!"
      content="Wij kunnen dit voor je bouwen! Heb je interesse?"
      link="Neem contact op met Thijs"
      class="-mt-96 mb-40 md:-mt-24 md:mb-0"
    />
    <simple-html-block
      :html-string="page.tekst"
    />
    <examples
      :html-string="page.voorbeelden"
    />
    <steps
      :html-string="page"
    />
    <benefits
      :html-string="page.voordelen"
    />
    <about
      :html-string="page.over"
    />
    <call-to-action
      title="Plan mij in!"
      content="Plan vrijblijvend een afspraak in met één van onze adviseurs."
      class="mb-32"
    />
  </section>
</template>

<script>
import About from '~/components/match/About';
import Benefits from '~/components/match/Benefits';
import CallToAction from '~/components/CallToAction';
import Examples from '~/components/match/Examples';
import HeaderMatch from '~/components/match/HeaderMatch';
import Steps from '~/components/match/Steps';
import SimpleHtmlBlock from '~/components/SimpleHtmlBlock';
import page from '~/plugins/mixins/page';

export default {
  components: {
    SimpleHtmlBlock,
    About,
    Benefits,
    CallToAction,
    Examples,
    HeaderMatch,
    Steps,
  },
  mixins: [page],
};
</script>
